import styled from 'styled-components';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.auth.lightPurple};
  margin-right: 2px;
  cursor: pointer;
  max-width: 170px;
  min-width: 170px;
  min-height: 134px;
`;

export const CardImage = styled.div`
  width: 100%;
  max-height: 92px;
  min-height: 92px;
  overflow: hidden;
  margin-bottom: 4px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ModelName = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  font-size: 1.5rem;
`;
